var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.793457H513V342.76H0V0.793457Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.793457H513V171.827H0V0.793457Z",
    fill: "#56AF35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 342.76L513 171.727L0 0.793457V342.76Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.963 232.746C168.629 232.746 195.882 205.493 195.882 171.827C195.882 138.161 168.629 110.908 134.963 110.908C101.297 110.908 74.0443 138.161 74.0443 171.827C74.0443 205.493 101.297 232.746 134.963 232.746ZM134.963 257.093C87.8713 257.093 49.5967 218.919 49.5967 171.727C49.5967 124.535 87.7711 86.3604 134.963 86.3604C182.155 86.3604 220.329 124.535 220.329 171.727C220.329 218.919 182.055 257.093 134.963 257.093Z",
    fill: "#FFC945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.733 166.917C129.417 166.917 137.268 159.067 137.268 149.383C137.268 139.699 129.417 131.849 119.733 131.849C110.05 131.849 102.199 139.699 102.199 149.383C102.199 159.067 110.05 166.917 119.733 166.917Z",
    fill: "#FFC945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.191 177.137C158.875 177.137 166.725 169.287 166.725 159.603C166.725 149.919 158.875 142.069 149.191 142.069C139.507 142.069 131.657 149.919 131.657 159.603C131.657 169.287 139.507 177.137 149.191 177.137Z",
    fill: "#FFC945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.963 153.792C144.647 153.792 152.497 145.942 152.497 136.258C152.497 126.574 144.647 118.724 134.963 118.724C125.279 118.724 117.429 126.574 117.429 136.258C117.429 145.942 125.279 153.792 134.963 153.792Z",
    fill: "#FFC945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.733 191.365C129.417 191.365 137.268 183.515 137.268 173.831C137.268 164.147 129.417 156.297 119.733 156.297C110.05 156.297 102.199 164.147 102.199 173.831C102.199 183.515 110.05 191.365 119.733 191.365Z",
    fill: "#FFC945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.193 201.485C159.877 201.485 167.727 193.635 167.727 183.951C167.727 174.267 159.877 166.417 150.193 166.417C140.509 166.417 132.659 174.267 132.659 183.951C132.659 193.635 140.509 201.485 150.193 201.485Z",
    fill: "#FFC945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.739 216.714C132.423 216.714 140.273 208.864 140.273 199.18C140.273 189.496 132.423 181.646 122.739 181.646C113.055 181.646 105.205 189.496 105.205 199.18C105.205 208.864 113.055 216.714 122.739 216.714Z",
    fill: "#FFC945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.185 223.929C155.869 223.929 163.719 216.078 163.719 206.395C163.719 196.711 155.869 188.86 146.185 188.86C136.501 188.86 128.651 196.711 128.651 206.395C128.651 216.078 136.501 223.929 146.185 223.929Z",
    fill: "#FFC945"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.793457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr);
export default __webpack_public_path__ + "static/media/ER.a80f79cf5d9d4f412c819ae0ebea3185.svg";
export { ForwardRef as ReactComponent };